import { ModalRef } from "../../types/refs";
import { useApp } from "../../hooks";
import { ModalProps } from "antd";
import Options from "./options";
import Dialog from "./dialog";
import Body from "./body";
import React, {
  useImperativeHandle,
  useCallback,
  useEffect,
  useRef,
} from "react";

interface Props extends Omit<ModalProps, "title" | "onClose"> {
  title?: string | ((data: any) => string);
  closeable?: boolean;
  child?: (data: any) => React.ReactNode;
  onClose?: () => void;
}

const Component = React.forwardRef<ModalRef, Props>(
  ({ title = "", child = () => null, children, ...props }, ref) => {
    const { modal } = useApp();
    const modalRef = useRef<any>();

    useEffect(() => {
      if (props.open !== undefined) props.open ? open() : close();
    }, [props.open]);

    const close = useCallback(() => {
      if (!!modalRef.current) {
        modalRef.current.destroy();
        modalRef.current = undefined;
      }
    }, []);

    const open = (data?: any) => {
      if (!!modalRef.current) return;
      modalRef.current = modal.show({
        onClose: close,
        content: children || child(data),
        title: typeof title === "function" ? title(data) : title,
        ...(props as any),
      });
    };

    useImperativeHandle(ref, () => ({ close, open }), [close, open]);

    return null;
  }
);

const Modal = Component as React.ForwardRefExoticComponent<
  Props & React.RefAttributes<ModalRef>
> & {
  Dialog: typeof Dialog;
  Options: typeof Options;
  Body: typeof Body;
};

Modal.Body = Body;
Modal.Dialog = Dialog;
Modal.Options = Options;
export default Modal;
